// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"mosque"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 4C14.7614 4 17 6.23858 17 9H20V21H4V9H7C7 6.23858 9.23858 4 12 4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M9 21V15H15V21H9Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 21V15H15V21H9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 9V21H20V9M4 9H3M4 9H7M20 9H21M20 9H17M7 9H17M7 9C7 6.23858 9.23858 4 12 4M17 9C17 6.23858 14.7614 4 12 4M12 4L12.002 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MosqueIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mosque',
    ref,
    icon: element,
  },
));

MosqueIcon.displayName = 'MosqueIcon';

export default MosqueIcon;
